<div class="container">

<mat-card>
<app-help-dialog-theproject></app-help-dialog-theproject>
</mat-card>

</div>